export class Product {

    constructor(
        public Id: number = 0,
        public UpdateId: string = '',
        public Name: string = '', 
        public Description: string = '',
        public Status: number = 0,
        public ImageUrl: string = '',
        public IconUrl: string = '')
    { }
}


// WEBPACK FOOTER //
// ./Client/app/models/Product.ts